import { Component } from '@angular/core';

@Component({
  selector: 'app-calculate-page',
  templateUrl: './calculate-page.component.html',
  styleUrls: ['./calculate-page.component.scss'],
})
export class CalculatePageComponent {
  displayedColumns2: string[] = ['assigned', 'name', 'priority', 'budget'];
  dataSource2 = [];
}
